var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`res-ico-${_vm.size} res-ico ${_vm.type}`,attrs:{"type":_vm.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }